import "./Imprint.module.css";
import Header from "@/reusable_sections/Header";
import LegalInformation from "./sections/LegalInformation";
import ContactDetails from "./sections/ContactDetails";
import Footer from "@/reusable_sections/Footer";
export default function ImprintPage() {
  return <div>
      <Header />
      <LegalInformation />
      <ContactDetails />
      <Footer />
    </div>;
}